// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageInfo from '../../package.json'

export const environment = {
  production: false,
  analyticsKey: 'testing',
  progressKey: 'ProgressTesting',
  name: 'sharp',
  appName: 'SHARP',
  urlScheme: 'delphiregsk',
  appId: 'com.bocodigital.gsk',
  version: packageInfo.version,
  homePage: [''],
  scormEngine: 'https://api.gettingsharpfcr.com',
  authConfig: {
    domain: 'auth.gettingsharpfcr.com',
    clientId: 'tYXdYUFE6l66UGkmjNFCXATev4lzr6EE',
    audience: 'https://iam.gettingsharpfcr.com',
    responseType: 'token id_token'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyDVS4CUQ2jgZ98HTk-UNwkt_Rb9OFOnJiM',
    authDomain: 'delphire-io-gsk.firebaseapp.com',
    databaseURL: 'https://delphire-io-gsk.firebaseio.com',
    projectId: 'delphire-io-gsk',
    storageBucket: 'delphire-io-gsk.appspot.com',
    messagingSenderId: '628392169938',
    appId: '1:628392169938:web:2eba8443c2d64925b7b80b',
    measurementId: '',
    vapidKey: 'BMMN7x9NV4lA0j5cUQghTAupXZOLbGH_UrOJkmzfgNfS6xsL6D3rZvjbjnF-h6hVJoVGWAgtWLIifXfMIX4BQNY',
    fallbackUrl : 'https://bocoweb.bocodigital.com/ios/apps/delphire-sharp/v4',
    iamId: 'delphire-io-gsk-state'
  },
  pspdfkit: {
    nativeLicense:
      '',
    license:
      //! LOCALHOST
      // 'faYVJD7CV3J7USDgGuWZW5nS5hVaS2TrdC2YPoXFIFbriTV5ZTUZN6KXZm6AlYNXnhT6pDp4Aji7Far1rFnZXA7_z6l-DLc5Rr6HGHJQX3Zv_Wm9t7rHy3fwU3cfXWdEGv431Wv35JP-3L4eFs0lt7bxUdgTor8EcY8k003lQJCMKbg6_V0mSBnI9ap1d5tDot5W2D8PXPrRqW079WUZuLliDbzF6PdaLQESqF7oIoI_qpYT4IZo1G9BhjlwNxSuoJ7J-HNEyiRCl-9sBwBfmn0MVaXg4J3kr3GiGsKjHhY0x27lB2z7C_FTj7R1dSnSEW9Bd9TIkXue_vtwRhurs-3-OsIEwYhT6vW9kur3-BZrL4AsuCNg0qpK5Q2l5-_UPt9EN6Sp6zh3ELWgycs7z99TBZw9ksxCa4b8n1ndGkJg4HWI9YmTvgYpJXlo_vJbtoXN6P9YCsefL5f226deBCgAKGB9O9-Qyzg_TwkceNbAcFkMu68t2UkClW0oJ_PmyxwHiDlqz5bQ25JiRK9U7YBPbT13u2QSWAT12iIf9DoEbsbjoj_KCKTpbnzFSrm6-xHn2CAJDNhHxpCwjTc8BLMMvRcnUadU1Qv8rqaftAQ=',
      //! PRODUCTION
      'tP1EQa11ZNrJgYkllT0FeVkIgEAZVwvP-pwDpyUlEjSLJIfsr6uSeMD2WD88fp0Alp7tLSEoiYlqcygBbyIhynqGm6L4dbbLIbMYLKP_mWI5gqHTQ4ucsd4u67__oV_blndSGtGmMhgkkBQBLkUWXWvc4GOXStz25Qk7wZ-ZVuFhYSYIxbUu-EuOpqNX_Y2OJPLnNArjjKvamYaruroLzYhxH3VncTvh6o2EEzks8sCFmvmT5EAXPdLDsfW_Vfkc8Oc2Cf8-zJgf5DlOjRCw6_01KR29JZAZCAWjQrwikk1M1lfDtb_9iqFzl6pmt0JVlMJqkwPtSl2PziLHxUJzwDIWQFCqBMtlDrgOdCUF8JuQb22i9fdYt6AEhwWK_xqNV50HMgseeTr54L_CNJ_nBTB44Skhww9aaMWH1NBtcLAfJLkrWHYcaupFgawNil4PxRmK3sg6wFZw00jaCvfz9UAPfurk52ZinvnogsJ-P37A0pzZ-ZaocGC6GQP31bZdX---Mbtr_I3lTMDDqHKjiCTullzqJgiMAYzGIXzodF1KgMe2xlMcYmVM3C4Yx4qhxdSnmcM5XKeucBRVqcJC0D4dr5iX7stCZMSjGm7gBTU='
  },
  firebasePaths: {
    state: 'environment/production/iam/state/',
    space: 'environments/production/'
  },
  appLanguage: {
    general: {
      networkConnectionMessageHeader: 'Network connection is required',
      networkConnectionMessage:
        'I am sorry. To use this resource, you must be connected to the Internet.',
      connectionLost: 'Your connection to the internet was lost.',
      connectionFound: 'Your internet connection seems to have returned.',
      reloadMessage: 'Please press OK to reload.',
      showMe: 'Show Me',
      downLoading: 'Downloading',
      dismiss: 'Dismiss',
      disclaimer:
        'Confidential – For internal educational use only. Execution to content must align to role responsibilities and comply with company policies & procedures.'
    },
    topNav: {
      loggedInAs: 'Logged in as',
      since: 'since',
      availableLayouts: 'Available Layouts',
      favorites: 'Favorites',
      preferences: 'Preferences',
      logOutNow: 'Logout now',
      yes: 'Yes',
      no: 'No',
      areYouSure: 'Are you sure?',
      sorry: 'Sorry',
      okay: 'Okay',
      maybeLater: 'Maybe Later'
    },
    modals: {
      workingOffline: 'You are working offline',
      preferences: {
        profile: 'Profile',
        dataManagement: 'Data Management',
        total: 'Total',
        allStorage: 'All Storage',
        features: 'Features',
        notifications: 'Notifications',
        defaultLayout: 'Default dashboard',
        defaultLayoutMessage:
          'Select a dashboard below to change the default dashboard.',
        defaultLayoutDisclaimer:
          'the dashboard can always be changed using the drop down menu at the top right at any time.',
        close: 'Close'
      },
      updateInProgressHeader: 'Update in progress',
      updateInProgressMessage:
        'Your dashboard and resources are being updated to reflect recent changes.',
      contentUnavailableHeader: 'This content is no longer available.',
      contentUnavailableMessage:
        'This content has been disabled. Please return to the main dashboard.',
      chooseLayoutHeader: 'Would you like to make this your default dashboard?',
      chooseLayoutMessage:
        'You can change the dashboard later by clicking on the avatar in the upper right corner of the application. You can also change your default dashboard by going to preferences.',
      logout: 'Logout',
      logOutMessage: 'You will be redirected to the login screen momentarily.'
    },
    widget: {
      disabled: 'Disabled',
      waiting: 'Waiting',
      week: 'Week',
      todaysTasks: 'Todays Tasks',
      noTasks: 'Today there are no tasks.',
      youHaveNoTasks: '',
      forCurrentWeek: '',
      minutes: 'mins',
      keyObjectives: 'Key Objectives',
      todoThisWeek: 'Tasks for this week'
    },
    library: {
      noFavoritesHeader: 'No favorites',
      noFavoritesMessage: 'You have not marked any favorites.',
      folderMessage: 'inside this folder',
      pages: 'pages',
      open: 'Open',
      myFavorites: 'My Favorites'
    },
    agenda: {
      viewPdf: 'View PDF',
      time: 'Time',
      description: 'Description',
      location: 'Location'
    },
    roadmap: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      week: 'Week',
      noTasksThisDay: '',
      checkAll: 'Check all',
      unCheckAll: 'Uncheck all'
    },
    quiz: {
      quiz: 'Knowledge Check',
      begin: 'Begin',
      close: 'Close',
      submit: 'Submit',
      correct: 'Correct',
      incorrect: 'Incorrect',
      continue: 'Continue',
      sorry: 'You did not successfully achieve a passing score.',
      congratulations: 'Congratulations!'
    }
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
